import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;
//开通工会卡
export const PostAddCardHolder = (params) => {
  return axios.post(`${base}/api/CardHolder/PostAddCardHolder`, params);
};

export const GetSelectCardHolder = (params) => {
  return axios.get(`${base}/api/CardHolder/GetSelectCardHolder`, {
    params: params,
  });
};
// 批量生成工会卡
export const PostBatchBuildCard = (params) => {
  return axios.post(`${base}/api/CardHolder/PostBatchBuildCard`, params);
};

// 获取工会卡
export const GetUnionCardList = (params) => {
  return axios.get(`${base}/api/CardHolder/GetUnionCardList`, {
    params: params,
  });
};

//导出台账列表
export const PostExportCardHolderExcel = (params) => {
  return axios.post(
    `${base}/api/CardHolder/PostExportCardHolderExcel`,
    params,
    { responseType: "blob" }
  );
};

// 导入Excel生成工会卡
export const PostImportCardHolderExcel = (formData) => {
  return axios.post(
    `${base}/api/CardHolder/PostImportCardHolderExcel`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// 删除工会卡

export const DeleteCardHolder = (params) => {
  return axios.post(`${base}/api/CardHolder/PostDeletesUnionCards`, params);
};

export const GetSendMessagePassPhone = (params) => {
  return axios.get(`${base}/api/CardHolder/GetSendMessagePassPhone`, {
    params: params,
  });
};

// 停用工会卡
export const turnOffCardHolder = (id) => {
  return axios.delete(`${base}/api/CardHolder/DeleteCardHolder?id=${id}`);
};

//获取工会卡剩余情况信息列表并导出
export const PostExportCardHolderRealExcel = (params) => {
  return axios.post(
    `${base}/api/CardHolder/PostExportCardHolderRealExcel`,
    params,
    { responseType: "blob" }
  );
};
